import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'app/models/user.model';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RecurrencyService {

  apiUrl: string = `${environment.apiUrl}recurrency`;
  constructor(private client: HttpClient) { }

  public getRecurrencies(){
    let enterprise: User = JSON.parse(sessionStorage.getItem('loggedUser'));
    return this.client.get<any[]>(this.apiUrl + `?enterpriseId=${enterprise.databaseId}`).toPromise();
  }

  public saveRecurrency(recurrency: any){
    if(recurrency.id){
      return this.client.put<any>(this.apiUrl, recurrency).pipe(catchError(this.handleError));
    }else{
      return this.client.post<any>(this.apiUrl, recurrency).pipe(catchError(this.handleError));
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}
